import { useSelector, useDispatch } from "react-redux";
import { setSelectedRegion } from "../../../store/pointsSlice";
import "./RegionLegend.css";
import React, { useRef, useState } from "react";
import { dedupeCo2Points } from "../../../utils/co2";

const wasteGroups = {
    mining: "Отходы горнодобычи",
    alkaline: "Щелочные отходы",
};

const RegionLegend = () => {
    const dispatch = useDispatch();
    const selectedRegion = useSelector((state) => state.points.selectedRegion);
    const points = useSelector((state) => state.points.points);

    const selectedYear = useSelector((state) => {
        return state.points.selectedYear || "2030";
    });

    const getCO2Value = (groupPoints) => {
        if (!groupPoints || groupPoints.length === 0) return "нет данных";

        let totalCO2 = 0;
        let wasteTypes = new Map();

        dedupeCo2Points(groupPoints).forEach((point) => {
            if (
                !point.co2Absorption ||
                typeof point.co2Absorption !== "object"
            ) {
                return;
            }

            const yearKey = selectedYear.toString();
            const co2Value = parseFloat(point.co2Absorption[yearKey]) || 0;

            totalCO2 += co2Value;

            const wasteType = point.wasteType || "Неизвестный";
            const currentValue = wasteTypes.get(wasteType) || 0;
            wasteTypes.set(wasteType, currentValue + co2Value);
        });

        if (totalCO2 <= 0) return "по запросу";

        const typeBreakdown = Array.from(wasteTypes.entries())
            .filter(([_, value]) => value > 0)
            .map(([type, value]) => `${type}: ${value.toFixed(2)}`)
            .join(", ");

        return `${totalCO2.toFixed(2).replace(".", ",")} тыс. т`;
    };

    const regionPoints = points.filter(
        (point) => point.region === selectedRegion
    );

    return (
        <div className="region-legend">
            <h3>{selectedRegion}</h3>{" "}
            <div className="waste-groups">
                {Object.entries(wasteGroups).map(([groupId, groupName]) => {
                    const groupPoints = regionPoints.filter(
                        (p) => p.group === groupId
                    );

                    if (groupPoints.length === 0) return null;

                    return (
                        <div key={groupId} className="waste-group">
                            <div className="waste-group-content">
                                <h4>
                                    {groupName} {}
                                </h4>
                                <p>Количество объектов: {groupPoints.length}</p>
                                <p>
                                    Потенциал поглощения CO2:{" "}
                                    {getCO2Value(groupPoints)}
                                </p>
                            </div>
                        </div>
                    );
                })}
            </div>
            <button
                className="back-button"
                onClick={() => dispatch(setSelectedRegion(null))}
            >
                Назад к регионам
            </button>
        </div>
    );
};

export default RegionLegend;
